import Vue from 'vue';
import Vuex from 'vuex';
import { includes, filter, find, map, get, every } from 'lodash';

import router from './router';

import {
  PeriodicElement,
  BonusPeriodicElement,
  elements,
  bonusElements,
  metaElements,
} from './data';

type ElementTypes = PeriodicElement | BonusPeriodicElement;

declare let window: WindowWithAnalytics;

Vue.use(Vuex);

interface Route {
  params: {
    element?: string;
  };
}

const mapVisited = (bonusEls: BonusPeriodicElement[], visited: string[]) =>
  map(bonusEls, el => ({
    ...el,
    unlockProgress:
      filter(el.prereqElements, (prereq: string) => includes(visited, prereq))
        .length / el.prereqElements.length,
  }));

export default new Vuex.Store({
  state: {
    unlockTracked: false,
    isFirstPage: true,
    selectedElements: [] as string[],
    hoveredElement: null,
    route: {
      params: {},
    } as Route,
    elements,
    bonusElements,
    metaElements,
  },
  mutations: {
    clearHovered(state) {
      state.hoveredElement = null;
    },
    setHovered(state, element) {
      state.hoveredElement = element;
    },
    addSelectedElement(state, element) {
      state.selectedElements = state.selectedElements.concat(element);
    },
    markFirstPage(state) {
      state.isFirstPage = false;
    },
  },
  actions: {
    visitElement({ state, commit, getters }, { element }) {
      window.analytics.track('Visit Element', { element });

      if (!includes(state.selectedElements, element) && element !== '404') {
        commit('addSelectedElement', element);
        if (getters.allUnlocked && !state.unlockTracked) {
          window.analytics.track('Unlocked All Signature Shots');
          window.analytics.identify({ unlockedAll: true });
          state.unlockTracked = true;
        }
      }
      commit('clearHovered');
      router.push(`/${element}`);
    },
  },
  getters: {
    selectedElement: state =>
      find(
        state.elements.concat(state.bonusElements).concat(state.metaElements),
        (el: ElementTypes) => el.element === state.route.params.element,
      ),
    hoveredElement: state =>
      find(state.bonusElements, el => el.element === state.hoveredElement),
    elementsWithUnlockable: (state, getters) => {
      const prereqs = get(getters.hoveredElement, 'prereqElements', []);

      return map(state.elements, el => ({
        ...el,
        activeUnlocker:
          includes(prereqs, el.element) &&
          !includes(state.selectedElements, el.element),
      }));
    },
    bonusElementsWithVisited: state =>
      mapVisited(state.bonusElements, state.selectedElements),
    allUnlocked: (state, getters) =>
      every(getters.bonusElementsWithVisited, el => el.unlockProgress === 1),
  },
});



// WEBPACK FOOTER //
// ./src/store.ts